<template>
  <v-container>
    <Navigation />
    <v-col
      cols="12"
      sm="12"
      xs="4"
      class="ml-2"
      :class="{ 'col-md-12': isChrome, 'col-md-10': isFirefox }"
    >
      <div class="container mx-5">
        <v-autocomplete
          @change="(event) => changeOper(event)"
          v-model="operDefault"
          filled
          outlined
          dense
          label="Operador"
          :rules="rules"
          item-value="operId"
          item-text="name"
          :items="getOperators"
          class="oper__input white"
          hide-details
        />
        <TableWithSearch
          :headers="allHeaders"
          :items="getEmployees"
          :openDialog="openDialog"
          :title="title"
          @headersUpdated="updateHeaders"
        />
      </div>
    </v-col>

    <v-dialog v-model="showAdd" max-width="500px" persistent>
      <v-card>
        <v-card-title class="flex-center">
          {{
            isEdit
              ? $tc("workflow.edit") + " " + $tc("workflow.employees")
              : $tc("workflow.add") + " " + $tc("workflow.employees") + " "
          }}
        </v-card-title>
        <div class="d-flex" v-if="isEdit" style="margin-left: 38px">
          <v-icon>mdi-account</v-icon>
          <v-card-subtitle class="mt-1"> {{ nameInEdit }}</v-card-subtitle>
        </div>

        <v-card-actions class="flex-center">
          <v-form ref="form" v-model="valid" style="width: 100%" class="mx-2">
            <Date />
            <v-alert
              dense
              v-if="error"
              color="red"
              elevation="5"
              outlined
              text
              type="error"
              align="center"
              class="mr-1 ml-1"
            >
              {{ alertValidate }}</v-alert
            >
            <v-alert
              v-if="showLimitAlert"
              type="warning"
              dense
              outlined
              @input="showLimitAlert = false"
            >
              {{ $tc("gestionEmpleados.OnlyUpTo300Employees") }}
            </v-alert>
            <v-autocomplete
              v-model="data.employees"
              outlined
              dense
              label="Empleados"
              :rules="rules"
              class="input__emp"
              item-value="empId"
              chips
              item-text="employee"
              :items="employeesWithSelectAll"
              multiple
              v-show="!isEdit"
              :filter="customFilter"
              :search-input.sync="searchEmployee"
            >
              <template v-slot:item="{ item }">
                <v-list-item @click.stop="toggleItem(item)">
                  <v-list-item-action>
                    <v-checkbox
                      :input-value="isSelected(item)"
                      :indeterminate="isIndeterminate(item)"
                      dense
                      hide-details
                      readonly
                    />
                  </v-list-item-action>
                  <v-list-item-content class="ml-n3">
                    <v-list-item-title>{{
                      item.empId === "all"
                        ? item.employee
                        : item.employee + " (" + item.file + ")"
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 2">
                  <span>{{
                    item.empId === "all"
                      ? item.employee
                      : item.employee + " (" + item.file + ")"
                  }}</span>
                </v-chip>
                <span v-if="index === 2" class="grey--text text-caption">
                  (+ {{ data.employees.length - 2 }} )
                </span>
              </template>
            </v-autocomplete>
          </v-form>
        </v-card-actions>
        <div class="d-flex justify-space-between pb-4 px-5">
          <v-btn class="bt-exit" @click="cancel"
            >{{ $tc("editRegistrations.cancel") }}
          </v-btn>
          <v-btn class="bt-acept" @click="validate">
            {{ $tc("editRegistrations.acept") }}</v-btn
          >
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDelete" max-width="450px" persistent>
      <v-card>
        <v-card-title class="flex-center">
          {{ $tc("workflow.delete") + " " + "a" + " " + nameInEdit }}
        </v-card-title>

        <v-card-actions class="flex-center">
          <div class="flex-center">
            <v-btn class="bt-exit mr-2 mb-2" @click="cancel"
              >{{ $tc("editRegistrations.cancel") }}
            </v-btn>
            <v-btn class="bt-acept" @click="deleteEmp">
              {{ $tc("editRegistrations.acept") }}</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Alerts :alert="errorAlert" :color="colorError" :textAlert="textAlertOk" />
    <Alerts :alert="ok" :color="colorOk" :textAlert="textAlertOk" />

    <Snackbar
      :alert="snackbarAlert"
      :color="snackbarColor"
      :textAlert="snackbarText"
    />
  </v-container>
</template>

<script>
import Navigation from "../commons/Navigation.vue";
import TableWithSearch from "../../Complement/TableWithSearch.vue";
import employeesW from "../../../store/workflow/employeesW";
import commons from "../../../store/workflow/commons";
import Loader from "../../Complement/Loader.vue";
import Alerts from "../../GestionEmpleados/commons/Alerts.vue";
import Date from "../../GestionEmpleados/commons/Date.vue";
import operators from "../../../store/workflow/operators";
import moment from "moment";
import attributes from "../../../store/workflow/attributes";
import configTable from "@/store/configuracionDeTablas/configTable.js";
import Snackbar from "../../Complement/Snackbar.vue";

export default {
  components: { Date, Navigation, TableWithSearch, Loader, Alerts, Snackbar },
  data() {
    return {
      title: "Empleados",
      titleTable: "WF_Empleados",
      type: "Empleados",
      search: "",
      error: false,
      alertValidate: "",
      valid: true,
      rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
      data: {
        operid: null,
        from: null,
        to: null,
        employees: [],
        haNoEx: false,
        nameOper: null,
        file: null,
      },
      isLoading: false,
      colorError: "#FF8D58",
      colorOk: "#82A1D0",
      textAlertOk: "",
      errorAlert: false,
      ok: false,
      showDelete: false,
      deleteItems: null,
      editItems: [],
      checkTo: this.$store.state.employees.checkTo,
      headers: [
        {
          text: "Empleado",
          value: "employee",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Desde",
          value: "from",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Hasta",
          value: "to",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          width: "150px",
          sortable: false,
        },
      ],
      operDefault: employeesW.state.operDefault,
      operFilter: {},
      nameInEdit: null,
      showLimitAlert: false,
      maxEmployees: 300,
      searchEmployee: "",
      snackbarAlert: false,
      snackbarColor: "#FF8D58",
      snackbarText: "",
    };
  },
  mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (
          configTable.state.colums.length === 0 ||
          configTable.state.colums.length !== this.headers.length
        ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
    this.isLoading = true;
    attributes.dispatch("getAttributes");
    employeesW.dispatch("getEmployees").then(() => {
      this.isLoading = false;
      this.$store.commit("employees/setCheckTo", true);

      if (this.operFilter && this.operFilter[0]) {
        let oper = this.operFilter[0];
        employeesW.commit("setOperDefault", oper);
        this.refreshEmployees(oper.operId);
        this.operDefault = oper;
      }

      operators.dispatch("getOperators");
    });
  },
  watch: {
    operDefault: function (newValue, oldValue) {
      this.operDefault = newValue;
    },
  },

  computed: {
    allHeaders() {
      return Array.isArray(configTable.state?.colums)
        ? configTable.state.colums
        : [];
    },
    getEmployees: {
      get() {
        return employeesW.state.employeesOperId;
      },
      set(newvalue) {},
    },
    showAdd: {
      get() {
        return commons.state.showAdd;
      },
      set(newValue) {
        return newValue;
      },
    },
    isChrome() {
      return (
        /Chrome/.test(navigator.userAgent) &&
        /Google Inc/.test(navigator.vendor)
      );
    },
    isFirefox() {
      return /Firefox/.test(navigator.userAgent);
    },
    isEdit: {
      get() {
        return commons.state.isEdit;
      },
      set(newValue) {
        return newValue;
      },
    },
    getOperators() {
      return attributes.state.attributes;
    },

    getAllOperators() {
      return attributes.state.attributes;
    },
    getAllEmployees() {
      return employeesW.state.employees;
    },
    filterEmployeesAll() {
      const employeeOperIds = employeesW.state.employeesOperId.map(
        (employee) => employee.empId,
      );
      const filteredEmployees = employeesW.state.employees.filter(
        (employee) => {
          return !employeeOperIds.includes(employee.empId);
        },
      );
      return filteredEmployees;
    },
    employeesWithSelectAll() {
      return [
        { empId: "all", employee: "Seleccionar todos", file: "" },
        ...this.filterEmployeesAll,
      ];
    },
  },
  methods: {
    isSelected(item) {
      if (item.empId === "all") {
        return this.data.employees.length === this.filterEmployeesAll.length;
      }

      return this.data.employees.includes(item.empId);
    },

    isIndeterminate(item) {
      if (item.empId !== "all") return false;

      return (
        this.data.employees.length > 0 &&
        this.data.employees.length < this.filterEmployeesAll.length
      );
    },

    toggleItem(item) {
      if (item.empId === "all") {
        const isAllSelected = this.data.employees.length > 0;

        if (isAllSelected) {
          this.data.employees = [];
          this.showLimitAlert = false;
        } else {
          const allIds = this.filterEmployeesAll.map((e) => e.empId);

          if (allIds.length > this.maxEmployees) {
            this.data.employees = allIds.slice(0, this.maxEmployees);
            this.showLimitAlert = true;
          } else {
            this.data.employees = allIds;
            this.showLimitAlert = false;
          }
        }

        this.searchEmployee = "";
        return;
      }

      const exists = this.data.employees.includes(item.empId);

      if (exists) {
        this.data.employees = this.data.employees.filter(
          (id) => id !== item.empId,
        );
        this.showLimitAlert = false;
      } else {
        if (this.data.employees.length >= this.maxEmployees) {
          this.showLimitAlert = true;
          return;
        }

        this.data.employees = [...this.data.employees, item.empId];

        if (this.data.employees.length === this.maxEmployees) {
          this.showLimitAlert = true;
        } else {
          this.showLimitAlert = false;
        }
      }

      this.searchEmployee = "";
    },

    customFilter(item, queryText) {
      const search = queryText.toLowerCase();

      return (
        item.employee?.toLowerCase().includes(search) ||
        item.file?.toString().toLowerCase().includes(search)
      );
    },
    updateHeaders(headers) {
      const updatedColums = headers;

      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    openDialog(type, item) {
      switch (type) {
        case "add":
          if (!this.operDefault || !this.operDefault.operId) {
            this.snackbarText = this.$tc("workflow.selectOperator");
            this.snackbarColor = "#FF8D58";
            this.snackbarAlert = true;

            setTimeout(() => {
              this.snackbarAlert = false;
            }, 4000);
            break;
          }
          this.data.operId = this.operDefault.operId;
          this.addExecution();
          break;
        case "edit":
          this.editExecution(item);
          break;
        case "delete":
          this.deleteExecution(item);
          break;

        default:
          break;
      }
    },
    addExecution() {
      commons.commit("setShowAdd", true);
      commons.commit("setIsEdit", false);
    },
    editExecution(item) {
      this.nameInEdit = item.employee;
      this.refreshEmployees(item.operId);
      commons.commit("setShowAdd", true);
      this.showAdd = true;
      commons.commit("setIsEdit", true);
      this.isEdit = true;
      this.data = {
        employees: item.empId,
        nameEmp: item.employee,
        nameOper: item.nameOper,
        operid: item.operId,
        haNoEx: item.to == " " ? true : false,
        from: item.from.slice(0, 10).split(/\D/).reverse().join("-"),
        to:
          item.to !== " "
            ? item.to.slice(0, 10).split(/\D/).reverse().join("-")
            : null,
        fromOld: item.from.slice(0, 10).split(/\D/).reverse().join("-"),
      };

      this.checkTo = item.to == " " ? true : false;
      this.$store.commit("employees/setCheckTo", this.checkTo);
      this.$store.commit("employees/setDateTo", this.data.to);
      this.$store.commit("employees/setDateFrom", this.data.from);
    },
    deleteExecution(item) {
      this.nameInEdit = item.employee;
      this.deleteItems = {
        from: item.from.slice(0, 10).split(/\D/).reverse().join("-"),
        empid: item.empId,
        operId: item.operId,
      };
      this.showDelete = true;
    },
    cancel() {
      if (this.showAdd) {
        commons.commit("setShowAdd", false);
        this.showAdd = false;
        this.isEdit = false;
        this.$refs.form.resetValidation();
        (this.data = {
          operid: null,
          from: null,
          to: null,
          employees: [],
        }),
          (this.ok = false);
        this.errorAlert = false;
        this.checkTo = true;
        this.showLimitAlert = false;
        const day = moment().format("YYYY-MM-DD");
        this.$store.commit("employees/setDateTo", null);
        this.$store.commit("employees/setDateFrom", day);
        this.$store.commit("employees/setCheckTo", this.checkTo);
      } else {
        this.showDelete = false;
      }
    },

    validate() {
      let valid = this.$refs.form.validate();
      if (this.$store.state.employees.checkTo) {
        this.data.to = null;
        this.data.haNoEx = true;
      } else {
        this.data.haNoEx = false;
      }
      if (valid) {
        if (this.isEdit) {
          this.edit();
        } else {
          this.add();
        }
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },
    add() {
      this.isLoading = true;

      let arrayEmployees = [];
      this.data.employees.forEach((e) => {
        arrayEmployees.push(this.searchEmp(e));
      });
      let payload = {
        operId: this.data.operId,
        fecDesde: this.$store.state.employees.dateFrom + "T00:00:00.000Z",
        fecHasta:
          this.$store.state.employees.dateTo !== null
            ? this.$store.state.employees.dateTo + "T00:00:00.000Z"
            : null,
        nomOper: this.searchOper(this.data.operId),
        empleados: this.data.employees,
        nombre: arrayEmployees,
      };

      let newOper = {
        operId: payload.operId,
        nameOper: payload.nomOper,
      };
      employeesW.commit("setNew", payload);
      employeesW
        .dispatch("new")
        .then(() => {
          this.refreshEmployees(payload.operId);
          this.operDefault = newOper;
          this.ok = true;
          this.isLoading = false;
          this.showLimitAlert = false;
          this.data.employees = [];
          this.textAlertOk = "Se agrego el nuevo empleado";
        })
        .catch((e) => {
          console.log(e);
          this.isLoading = false;
          this.errorAlert = true;
          this.textAlertOk = e.response.data.error.message;
        });

      this.cancel();
    },

    edit() {
      this.isLoading = true;
      let payload = {
        operid: this.data.operid,
        employees: this.data.employees,
        from: this.$store.state.employees.dateFrom,
        to: this.$store.state.employees.dateTo,
        haNoEx: this.data.haNoEx,
        nameEmp: this.data.nameEmp,
        fromOld: this.data.fromOld,
        nameOper: this.data.nameOper,
      };

      let newOper = {
        operId: payload.operid,
        nameOper: payload.nameOper,
      };
      employeesW.commit("setEdit", payload);
      employeesW
        .dispatch("edit")
        .then(() => {
          this.refreshEmployees(payload.operid);
          this.operDefault = newOper;
          employeesW.dispatch("getEmployees");
          this.ok = true;
          this.isLoading = false;
          this.textAlertOk = "Se edito el empleado";
        })
        .catch((e) => {
          console.log(e);
          this.isLoading = false;
          this.errorAlert = true;
          this.textAlertOk = e.response.data.error.message;
        });
      this.cancel();
    },
    deleteEmp() {
      this.isLoading = true;
      employeesW.commit("setDeleteItem", this.deleteItems);
      employeesW
        .dispatch("delete")
        .then(() => {
          this.refreshEmployees(this.deleteItems.operId);
          this.ok = true;
          this.isLoading = !this.isLoading;
          this.textAlertOk = "Se elimino el empleado";
        })
        .catch((e) => {
          console.log(e);
          this.isLoading = !this.isLoading;
          this.errorAlert = true;
          this.textAlertOk = e.response.data.error.message;
        });

      this.cancel();
    },
    searchEmp(item) {
      let name = employeesW.state.employees.filter(
        (element) => {
          return element.empId === item;
        },
        [0],
      );
      return name[0].employee;
    },
    changeOper(event) {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = !this.isLoading;
      }, 1000);

      this.refreshOper(event);
      this.refreshEmployees(event);
    },
    searchOper(item) {
      let name = operators.state.operators.filter(
        (element) => {
          return element.operId === item;
        },
        [0],
      );
      return name[0].nombre;
    },

    refreshEmployees(item) {
      let result = employeesW.state.employees.filter(
        (element) => element.operId == item,
      );
      this.getEmployees = result;
      employeesW.commit("setEmployeesOperId", result);
    },
    refreshOper(item) {
      let oper = attributes.state.attributes.filter((element) => {
        return element.operId === item;
      });
      let newOper = {
        operId: oper[0]?.operId,
        nameOper: oper[0]?.nameOper,
      };

      employeesW.commit("setOperDefault", newOper);
      this.operDefault = newOper;
    },
  },
};
</script>

<style scoped>
.flex-center {
  display: flex;
  justify-content: center;
}

.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}

.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
.oper__input {
  max-width: 220px !important;
  margin-top: -25px;
  margin-bottom: 10px;
}

.container {
  max-width: 100%;
}
</style>
